/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  if (!window.fbq) {
    return console.warn('Facebook Pixel unavailable')
  }

  $(document).on('click', 'a[data-facebook-pixel-event]', function(event) {
    var eventType = $(event.target).attr('data-facebook-pixel-event')
    window.fbq('track', eventType)
    console.info('Sending Facebook pixel event', eventType)
  })
}
